export const CUSTOMER_NOTIFICATION_STATUS_NOTIFIED = "82dac1aa-6409-4244-b233-b7d80269942f";
export const CUSTOMER_NOTIFICATION_STATUS_NOT_NOTIFIED = "255940b7-97c8-49af-a0c7-c068d0e2081d";

export const AIRPORT = "18BBA3CC-98F7-41A7-A7BE-30FD7BB79634";
export const PLANE = "6ACD768A-6F9F-412F-B980-CD3C1DCBC9AA";

export const DEFAULT_STORAGE_LOCATION = "1";

export const BRAND_COLOR = "#bc231e";

export const BASE_URL_API = process.env.REACT_APP_BASE_URL_API || "";
export const BASE_URL_DAL = process.env.REACT_APP_BASE_URL_DAL || "";
export const BASE_URL_REKOGNITION = process.env.REACT_APP_BASE_URL_REKOGNITION || "";

const two_minutes_logout_time = 2 * 60 * 1000;
const two_hours_logout_time = 2 * 60 * 60 * 1000;

export const INACTIVITY_LOGOUT_TIME = two_hours_logout_time;

export const STORAGE_KEY_AUTH = "auth";
export const STORAGE_KEY_LAST_ACTIVITY = "lastActivity";

// Define a list of stop words to ignore for highlighting
export const stopWords = new Set([
	"a",
	"an",
	"and",
	"are",
	"as",
	"at",
	"be",
	"but",
	"by",
	"for",
	"if",
	"in",
	"into",
	"is",
	"it",
	"no",
	"not",
	"of",
	"on",
	"or",
	"such",
	"that",
	"the",
	"their",
	"then",
	"there",
	"these",
	"they",
	"this",
	"to",
	"was",
	"will",
	"with",
]); 

export const ROLE_SETTINGS_BACKKOFFICE_ADMIN = 26;
